module.exports = __webpack_public_path__ + "img/hamburger-icon-dark.5fd22b4b.svg";